import { PlusOutlined } from "@ant-design/icons";

export const customUploaderBtn = (lab) => {
    return (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined style={{ fontSize: 20, color: '#afafaf' }} />
            <div style={{ marginTop: 8, fontSize: 14, color: '#afafaf' }}>{lab}</div>
        </button>
    );
}